import { render } from "./CreateSystem.vue?vue&type=template&id=6b3b8def&ts=true"
import script from "./CreateSystem.vue?vue&type=script&lang=ts"
export * from "./CreateSystem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__